var sw = sw || {};

sw.toggleMenu = function() {

	var $toggleButton = $('.js_toggleMobile');
	var $toggleNavigation = $('#navigation');

	if (!$toggleButton.length) {
        return;
    }

    // //START Locking body scroll logic
    var $body = $('body'),
        scrollDisabled = false,
        scrollTop;

	$toggleButton.on('click', function(e) {
		e.preventDefault();

		$toggleButton.toggleClass('is_open');
		$toggleNavigation.toggleClass('is_open');

		if( scrollDisabled ) {
            $body.removeClass('locked');
            $(window).scrollTop(scrollTop);
            scrollDisabled = false;
        } else {
            scrollTop = $(window).scrollTop();
            $body.addClass('locked').css({ top: -1 * scrollTop });
            scrollDisabled = true;
        }

	});

	$('body').on('click', '.nav li a', function() {
        $body.removeClass('locked');
        $(window).scrollTop(scrollTop);
        scrollDisabled = false;
    });

}

sw.toggleSubMenuMobile = function() {

    $('body').off('click', 'li.has__children .toggle');

    $('body').on('click', 'li.has__children .toggle', function(e){
        $(this).toggleClass('is_open');
        $(this).next('.children').stop().slideToggle();
    });

};

$(document).ready(function (){
    sw.toggleMenu();
    sw.toggleSubMenuMobile();
});